import React from "react";
import { Link } from "react-router-dom";

import Modal from "./Modal";
import { getMediaUrl } from "../lib/utils";

const ProfileFollowship = ({ isOpen, isClose, type, followers, following, followersCount, followingCount }) => {
  const isFollowers = type === "followers";
  const count = isFollowers ? followersCount : followingCount;
  const users = isFollowers ? followers : following;

  const title = () => {
    if (!count) return null;
    return isFollowers ? `${count} Follower${count > 1 ? "s" : ""}` : `${count} Following`;
  };

  return (
    <Modal isOpen={isOpen} isClose={isClose} title={title}>
      {!count ? (
        <div className="flex h-[220px] flex-col items-center justify-center text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gray-100">
            <img src="/assets/icons/people.svg" alt={isFollowers ? "followers" : "following"} className="h-6 w-6 opacity-60" />
          </div>

          <h3 className="mt-4 text-base font-semibold text-gray-800">
            {isFollowers ? "No followers yet" : "No following yet"}
          </h3>

          <p className="mt-1 text-sm text-gray-400">
            {isFollowers ? "Followers will appear here." : "Accounts you follow will appear here."}
          </p>
        </div>
      ) : (
        <div className="max-h-[360px] overflow-y-auto pr-1">
          <div className="divide-y divide-gray-100">
            {users?.map((f) => (
              <div key={f?.id} className="flex items-center justify-between gap-3 py-3">
                {/* USER LINK */}

                <Link to={`/profile/${f?.id}`} onClick={isClose} className="flex min-w-0 items-center gap-3">
                  <img src={getMediaUrl(f?.profile_img)} alt={`${f?.firstname} ${f?.lastname}`} className="h-12 w-12 shrink-0 rounded-full object-cover ring-1 ring-gray-200" />

                  <div className="min-w-0">
                    <p className="truncate text-sm font-semibold text-gray-800">{f?.firstname} {f?.lastname}</p>
                    <p className="mt-0.5 text-xs text-gray-400">{isFollowers ? "Follower" : "Following"}</p>
                  </div>
                </Link>

                {/* PROFILE BUTTON */}

                <Link to={`/profile/${f?.id}`} onClick={isClose} className="shrink-0 rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs font-semibold text-gray-600 transition hover:border-purple-200 hover:bg-purple-50 hover:text-purple-600">
                  Profile
                </Link>
              </div>
            ))}
          </div>
        </div>
      )}
    </Modal>
  );
};

export default ProfileFollowship;